import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ScannerPage from './pages/ScannerPage'
import ResultsPage from './pages/ResultsPage'
import SettingsPage from './pages/SettingsPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import BottomNav from './components/BottomNav'
import Footer from './components/Footer'

function App() {
  return (
    <BrowserRouter>
      <div
        className="min-h-screen bg-canvas text-fg"
        style={{ paddingBottom: 'calc(3.5rem + env(safe-area-inset-bottom, 0px))' }}
      >
        <Routes>
          <Route path="/results/:ean" element={<ResultsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/privatnost" element={<PrivacyPage />} />
          <Route path="/uvjeti" element={<TermsPage />} />
          <Route path="*" element={<ScannerPage />} />
        </Routes>
        <Footer />
        <BottomNav />
      </div>
    </BrowserRouter>
  )
}

export default App
